import { getActionTypes } from '../../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('picklistManagement')([
  'SET_LOADER',
  'LOAD_PICKLISTS',
  'UPSERT_PICKLIST',
  'DELETE_PICKLIST',
  'SET_FORM_LOADER',
  'SET_ASSET_ATTRIBUTES',
]);

export function setAssetAttributes(assetAttributes) {
  return { type: types.SET_ASSET_ATTRIBUTES, assetAttributes };
}

export function loadPicklist(picklists) {
  return { type: types.LOAD_PICKLISTS, picklists };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function setFormLoader(loader) {
  return { type: types.SET_FORM_LOADER, loader };
}

export function upsertPicklist(picklist) {
  return { type: types.UPSERT_PICKLIST, picklist };
}

export function deletePicklist(picklist) {
  return { type: types.DELETE_PICKLIST, picklistId: picklist.id };
}

export default function picklistReducer(
  state = { isPicklistPageLoading: true, picklists: [], isPicklistFormLoading: false, assetAttributes: [] },
  action
) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isPicklistPageLoading: action.loader };
    }
    case types.SET_FORM_LOADER: {
      return { ...state, isPicklistFormLoading: action.loader };
    }
    case types.LOAD_PICKLISTS: {
      return { ...state, picklists: action.picklists };
    }
    case types.DELETE_PICKLIST: {
      return {
        ...state,
        picklists: state.picklists.filter(({ id: picklistId }) => picklistId !== action.picklistId),
      };
    }
    case types.UPSERT_PICKLIST: {
      const { picklist } = action;
      return {
        ...state,
        picklists: [...state.picklists.filter(({ id: picklistId }) => picklistId !== picklist.id), picklist],
      };
    }
    case types.SET_ASSET_ATTRIBUTES: {
      const { assetAttributes } = action;
      return { ...state, assetAttributes };
    }
    default:
      return state;
  }
}

export const getAllAssetAttributesSelector = (state) => state.picklistReducer.assetAttributes;
export const allPicklistsSelector = (state) => state.picklistReducer.picklists;
